import React, { useState } from 'react';
import {
  Button,
  ColorBadge,
  HighlightIcon,
  IconTrashFilled,
  Input,
  Modal,
} from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import toast from 'react-hot-toast';
import { useAuth } from '~/context/AuthContext';
import {
  ContainerDelete,
  ContainerTrash,
  FooterPrinterDelete,
  HeaderPrinterDelete,
  NamePrinter,
  TextTrash,
} from '../styles';

export const PrinterModalDelete = ({
  open,
  onClose,
  isEdit = false,
  printerData,
  printerNames = [],
  printerNamesLoading = false,
  onPrinterUpdate,
  onPrinterDelete,
  isDelete = false,
}) => {
  const { user } = useAuth();
  const [password, setPassword] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!printerData.id) return;
    if (password !== user.order_cancel_password) {
      toast.error('Senha administrativa errada');
      return;
    }
    setIsDeleting(true);
    await api
      .delete(`/restaurants/printers/${printerData.id}`)
      .then(() => {
        console.log('Printer deleted successfully');
        toast.success('Impressora excluída com sucesso');
        onPrinterDelete(printerData.id);
      })
      .catch((error) => {
        console.error('Error deleting printer:', error);
        toast.error('Erro ao excluir impressora');
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <Modal
      open={open}
      toggle={onClose}
      style={{
        height: 'auto',
        width: 544,
        maxWidth: 544,
        position: 'relative',
        padding: 16,
        display: 'flex',
        gap: 24,
      }}
    >
      <ContainerDelete>
        <HighlightIcon
          style={{ height: 52, width: 52 }}
          icon={<IconTrashFilled />}
          size={20}
        />
        <ContainerTrash>
          <HeaderPrinterDelete>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <TextTrash>Deseja excluir permanentemente?</TextTrash>
              <NamePrinter>{printerData?.name}</NamePrinter>
            </div>
            <Input
              style={{ width: '100%' }}
              label="Senha administrativa"
              placeholder="Informe a senha"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <ColorBadge
              style={{
                width: '100%',
                padding: '12px 16px',
                justifyContent: 'flex-start',
              }}
            >
              Excluir a impressora pode parar sua operação
            </ColorBadge>
          </HeaderPrinterDelete>
        </ContainerTrash>
      </ContainerDelete>
      <FooterPrinterDelete>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          disabled={!password}
          isLoading={isDeleting}
          onClick={handleDelete}
          variant="outlined"
        >
          Excluir
        </Button>
      </FooterPrinterDelete>
    </Modal>
  );
};
